import { observer } from 'mobx-react-lite';
import PreviewLayout from './PreviewLayout';
import type { PreviewLayoutProps, PreviewLayoutValueProps } from './types';

export type { PreviewLayoutProps, PreviewLayoutValueProps };
export default observer(PreviewLayout); // MANUAL OVERRIDE
